import React, { useState, useEffect, useCallback } from "react";
import { publish } from "pubsub-js";
import eventType from "../../events/eventType";
import { css } from "emotion";
import { withRouter } from "react-router";
import { Helmet } from "react-helmet";
import { Panel, PanelHeader, PanelContent, PanelFooter } from "../../../shared/create-offer/Panel";
import Button from "../../../shared/button/button";
import TimelineSteps from "../../../shared/create-offer/TimelineSteps/TimelineSteps";
import RegistrationData from "../../components/new-offer/step2-registrationData";
import OfferMiles from "../../components/new-offer/step3-offerMiles";
import RegistrationCreditCard from "../../components/new-offer/step4-registrationCreditCard";
import FinishedOffer from "../../components/new-offer/step5-finishedOffer";
import { useNewOffer } from "../../context/new-offer";
import BoxTotalExpectedGain from "../../../shared/create-offer/BoxTotalExpectedGain/BoxTotalExpectedGain";
import {
	ROUTE_HOME,
	ROUTE_PREFIX_CREATE_OFFER,
	prefixFidelityAndBank,
	prefixOfferMiles,
	prefixCreditCard,
	prefixFinished,
	prefixValidateOffer,
	prefixFinishedError
} from "../../shared/constants";
import {
	CriarOfertaModal,
	EditarOfertaModal,
	OfertaEmVendaModal,
	VinduloPendenteModal,
	VendaRapidaNaoElegivel,
	PagamentoAntecipadoNaoElegivel
} from "../../services/modals";
import Loading from "../../../shared/create-offer/Loading/Loading";
import { loadingStyle } from "./style";
import { handleFidelityNameToPath, uuid } from "../../shared/utils";
import ResultOffer from "./step6-resultOffer";
import AcceptanceTerms from "../../../shared/create-offer/AcceptanceTerms/AcceptanceTerms";
import { GOL_ACRONYM, GOL_FIDELITY_PROGRAM, Type2FA } from "../../../../js/shared/constants";
import ModalErrorTwoFactorAuthentication from "../../../shared/create-offer/ModalErrorTwoFactorAuthentication/ModalErrorTwoFactorAuthentication";
import ModalProcessingTwoFactorAuthentication from "../../../shared/create-offer/ModalProcessingTwoFactorAuthentication/ModalProcessingTwoFactorAuthentication";
import Await2FAModal from "../../../shared/create-offer/Await2FAModal/Await2FAModal";

const NewOfferCreate = ({ match, history }) => {
	const {
		currentProgram,
		userData,
		newOfferTempData,
		offerData,
		pricesData,
		editOffer,
		creditCardData,
		quickSaleProblem,
		setQuickSaleProblem,
		selectOfferToEdit,
		postData,
		participantData,
		acceptanceTerms,
		setAcceptanceTerms,
		forwardPaymentProblem,
		setForwardPaymentProblem,
		loyaltyData,
		uuidCybersource,
		setUuidCybersource,
		bankData,
		banks,
		email2FAStatusValidation,
		showModalErrorTwoFactorAuthentication,
		setShowModalErrorTwoFactorAuthentication,
		twoFactorData,
		send2FACode,
		hasClickedRequest2FACode,
		setHasTriedToProceedWithout2FA
	} = useNewOffer();
	const typePhoneLatam = loyaltyData.data.phoneRequiredMode;
	const [index, setIndex] = useState(0);
	const [approvedSteps, setApprovedSteps] = useState(1);
	const [modals, setModals] = useState({
		ofertaEmVenda: false,
		ofertaNaoAprovada: false,
		vinculoPendente: false,
		criarOferta: false,
		twoFactor: false
	});
	const [showCreditCard] = useState(
		!creditCardData.hasCreditCard &&
			currentProgram &&
			currentProgram.international === "1" &&
			(currentProgram.id == 25 ||
				currentProgram.id == 11 ||
				currentProgram.id == 10 ||
				currentProgram.id == 14)
	);
	const [stepsData] = useState([
		{
			label: "Programa de fidelidade"
		},
		{
			label: "Oferta de milhas"
		},
		{
			label: "Dados de cadastro"
		},
		...(!creditCardData.hasCreditCard &&
		currentProgram &&
		currentProgram.international === "1" &&
		(currentProgram.id == 25 ||
			currentProgram.id == 11 ||
			currentProgram.id == 10 ||
			currentProgram.id == 14)
			? [
					{
						label: "Dados do cartão"
					}
			  ]
			: [])
	]);

	const isQuickSale = editOffer && editOffer.quickSale;
	const isForwardPayment = editOffer && editOffer.forwardPayment;

	const closeTwoFactorModal = () => {
		setModals({ ...modals, twoFactor: false });
		nextStep(undefined, true);
	};

	const handleTwoFactorModalConfirm = () => {
		send2FACode();
		closeTwoFactorModal();
	};

	const handleTwoFactorModalCancel = () => {
		closeTwoFactorModal();
	};

	useEffect(() => {
		return () => {
			selectOfferToEdit({}); // Limpa edição
		};
	}, []);

	useEffect(() => {
		setModals({
			...modals,
			vendaRapidaNaoElegivel: quickSaleProblem,
			pagamentoAntecipadoNaoElegivel: forwardPaymentProblem,
			vinculoPendente: participantData.isDone && participantData.hasRelationshipPendent
		});
	}, [quickSaleProblem, participantData, forwardPaymentProblem]);

	const divLoading = (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<Loading width={120} height={120} />
		</div>
	);

	const buildPath = (prefix, noProgram) => {
		return `${prefix}${noProgram ? "" : `/${handleFidelityNameToPath(currentProgram)}`}`;
	};

	const steps = [
		{
			path: buildPath(prefixFidelityAndBank),
			component: () => (
				<RegistrationData
					typePhoneLatam={typePhoneLatam}
					loading={userData.isFetching}
					fidelityProgram={currentProgram}
				>
					<AcceptanceTerms
						acceptanceTerms={acceptanceTerms}
						setAcceptanceTerms={setAcceptanceTerms}
					/>
				</RegistrationData>
			)
		},
		{
			path: buildPath(prefixValidateOffer),
			component: () => <FinishedOffer history={history} />
		}
	];
	if (!isQuickSale && !isForwardPayment) {
		steps.splice(0, 0, {
			path: buildPath(prefixOfferMiles),
			component: () =>
				userData.isFetching ||
				modals.vendaRapidaNaoElegivel ||
				modals.pagamentoAntecipadoNaoElegivel ? (
					divLoading
				) : (
					<OfferMiles typePhoneLatam={typePhoneLatam} />
				)
		});
	}

	if (showCreditCard) {
		steps.splice(steps.length - 1, 0, {
			path: buildPath(prefixCreditCard),
			component: () => <RegistrationCreditCard />
		});
	}

	const matchPath = `${match.params.path}/${match.params.step}`;
	const matchIndex = steps.findIndex(step => step.path === matchPath);

	const currentStep = steps[index] || {
		path: buildPath(prefixFinished),
		component: () => <ResultOffer typePhoneLatam={typePhoneLatam} />
	};

	useEffect(() => {
		if (matchIndex > index) {
			history.push(`${ROUTE_PREFIX_CREATE_OFFER}/${currentStep.path}`);
		} else if (steps[matchIndex]) {
			setIndex(matchIndex);
		} else if (
			match.params.path &&
			(match.params.path.includes(prefixFinished) ||
				match.params.path.includes(prefixFinishedError))
		) {
			setIndex(steps.length);
		}
	}, [match, history, matchIndex]);

	useEffect(() => {
		window.scrollTo(0, 0);
		if (!currentProgram.id) {
			history.push(ROUTE_HOME);
		} else if (currentStep.path && !currentStep.path.includes(prefixFinished)) {
			history.push(`${ROUTE_PREFIX_CREATE_OFFER}/${currentStep.path}`);
		}
	}, [index]);

	// Controla os steps
	const nextStep = useCallback((ev, ignoreModal = false) => {
		const { fidelityName, international } = currentProgram;
		const { quant: quantityMiles, price: priceMiles, averageMiles } = offerData?.data;
		const { path: step } = currentStep;
		const { bankId } = bankData?.data;
		const { paymentDeadline } = editOffer;
		const { twoFactorAuthenticationStrategy } = loyaltyData?.data;
		const bank = bankId ? banks?.data.find(bankData => bankData.idBank === bankId)?.name : "";

		publish(eventType.OFFER_CONTENT, {
			fidelityName,
			international,
			quantityMiles,
			bank,
			priceMiles,
			step: step.split("/")[0],
			averageMiles,
			paymentDeadline,
			twoFactorAuthenticationStrategy
		});

		let newIndex = index + 1;

		if (index === steps.length - 2 && twoFactorData.is2FAEnabled && !hasClickedRequest2FACode) {
			setHasTriedToProceedWithout2FA(true);
			return;
		}

		if (!ignoreModal && twoFactorData.is2FAEnabled && index === steps.length - 2) {
			setModals({ ...modals, twoFactor: true });
			return;
		}

		if (
			!ignoreModal &&
			index === steps.length - 2 &&
			(currentProgram.id === 1 || currentProgram.id === 3)
		) {
			if (typePhoneLatam === 0) {
				setModals({
					...modals,
					criarOferta: true
				});
				return;
			} else {
				criarOfertaConfirm();
				return;
			}
		}

		if (newIndex === steps.length - 1) {
			if (
				currentProgram.id === GOL_FIDELITY_PROGRAM &&
				loyaltyData.data.twoFactorAuthenticationStrategy === Type2FA.EMAIL_REDIRECT &&
				!email2FAStatusValidation.isValidated
			) {
				newIndex = newIndex - 1;
			}
			postData();
		}

		setIndex(newIndex);

		[
			offerData,
			pricesData,
			currentProgram,
			editOffer,
			currentStep,
			steps,
			approvedSteps,
			loyaltyData
		];
	});

	const prevStep = () => {
		if (index > 0) {
			setIndex(index - 1);
		} else {
			selectOfferToEdit({}); // Limpa edição
			history.push(ROUTE_HOME);
		}
	};

	const checkNextDisabled = () => {
		const hasInvalidOfferData = offerData?.data?.invalid;
		const isFetchingData = offerData.isFetching || pricesData.isFetching || userData.isFetching;
		const phone = loyaltyData?.data?.phone ?? "";

		if (hasInvalidOfferData || isFetchingData) {
			return true;
		} else if (
			currentStep.path.includes(prefixFidelityAndBank) &&
			((!newOfferTempData.form.completedBoxDataBankDetails &&
				!participantData.hasManagementActive) ||
				!loyaltyData?.data?.password ||
				loyaltyData?.data?.password?.length < 3 ||
				(typePhoneLatam === 0 &&
					phone?.length !== 11 &&
					!newOfferTempData.form.completedBoxDataFidelityProgramDetails) ||
				(currentProgram.acronym === GOL_ACRONYM &&
					!newOfferTempData.form.completedBoxDataFidelityProgramDetails) ||
				(typePhoneLatam === 2 && phone?.length !== 11) ||
				(phone &&
					phone?.length !== 11 &&
					phone?.length !== 0 &&
					typePhoneLatam !== 0 &&
					loyaltyData?.data?.id === 3) ||
				(phone &&
					phone[2] !== "9" &&
					loyaltyData?.data?.id === 3) ||
				!acceptanceTerms)
		) {
			return true;
		} else if (
			currentStep.path.includes(prefixOfferMiles) &&
			!newOfferTempData.form.completedBoxOfferMiles
		) {
			return true;
		} else if (
			currentStep.path.includes(prefixCreditCard) &&
			!newOfferTempData.form.completedBoxCreditCardDetails
		) {
			return true;
		}
		return false;
	};

	const editarOfertaConfirm = ev => {
		setModals({
			...modals,
			editarOferta: false
		});
		nextStep(ev, true);
	};

	const editarOfertaCancel = () => {
		setModals({
			...modals,
			editarOferta: false
		});
	};

	const criarOfertaConfirm = ev => {
		setModals({
			...modals,
			criarOferta: false
		});
		nextStep(ev, true);
	};

	const criarOfertaCancel = () => {
		setModals({
			...modals,
			criarOferta: false
		});
	};

	useEffect(() => {
		if (uuidCybersource) return;
		setUuidCybersource(uuid());
	}, [uuidCybersource]);

	useEffect(() => {
		if (email2FAStatusValidation.isValidated) {
			setIndex(prevIndex => prevIndex + 1);
		}
	}, [email2FAStatusValidation]);

	return (
		<div className="new-offers">
			{uuidCybersource && (
				<Helmet>
					<script
						src={`https://h.online-metrix.net/fp/tags.js?org_id=${process.env.CS_TOKEN}&session_id=${process.env.ID_CYBERSOURCE}${uuidCybersource}`}
						type="text/javascript"
					/>
					<noscript>
						{`
        				<iframe
						title='cyber'
						src=https://h.online-metrix.net/fp/tags.js?org_id=${process.env.CS_TOKEN}&session_id=${process.env.ID_CYBERSOURCE}${uuidCybersource}
						/>
						`}
					</noscript>
				</Helmet>
			)}
			<Panel overflow={false}>
				{index <= steps.length - 2 ? (
					<PanelHeader className="flex-column">
						<TimelineSteps data={stepsData} step={index + 1} approvedSteps={approvedSteps} />
					</PanelHeader>
				) : (
					<></>
				)}
				<PanelContent>{currentStep.component()}</PanelContent>
				{index <= steps.length - 2 ? (
					<PanelFooter className="new-offers--panel-footer">
						{isQuickSale || isForwardPayment ? (
							<br />
						) : (
							<Button
								className={"btn-gray-lg-o"}
								onClick={() => prevStep()}
								data-action="steps-prev"
							>
								Voltar
							</Button>
						)}
						{currentStep.path.includes(prefixOfferMiles) && <BoxTotalExpectedGain />}
						<Button
							disabled={checkNextDisabled()}
							onClick={() => nextStep()}
							className={"btn-primary-lg"}
							data-action="steps-next"
						>
							{index === steps.length - 2 ? "Concluir" : "Próximo"}
						</Button>
					</PanelFooter>
				) : (
					<></>
				)}
			</Panel>
			<VendaRapidaNaoElegivel
				show={modals.vendaRapidaNaoElegivel}
				onConfirm={() => {
					setQuickSaleProblem(false);
					editOffer.quickSale = undefined;
					setModals({ ...modals, vendaRapidaNaoElegivel: false });
				}}
			/>
			<PagamentoAntecipadoNaoElegivel
				show={modals.pagamentoAntecipadoNaoElegivel}
				onConfirm={() => {
					setForwardPaymentProblem(false);
					editOffer.forwardPayment = undefined;
					editOffer.paymentDeadline = undefined;
					setModals({ ...modals, pagamentoAntecipadoNaoElegivel: false });
				}}
			/>
			<OfertaEmVendaModal
				show={modals.ofertaEmVenda}
				onConfirm={() => {
					selectOfferToEdit({}); // Limpar oferta
					history.push(ROUTE_HOME);
				}}
			/>
			<EditarOfertaModal
				show={modals.editarOferta}
				onConfirm={editarOfertaConfirm}
				onCancel={editarOfertaCancel}
			/>
			<CriarOfertaModal
				show={typePhoneLatam === 0 && modals.criarOferta}
				onConfirm={criarOfertaConfirm}
				onCancel={criarOfertaCancel}
			/>
			<VinduloPendenteModal
				show={modals.vinculoPendente}
				onConfirm={() => {
					setModals({ ...modals, vinculoPendente: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<ModalErrorTwoFactorAuthentication
				show={showModalErrorTwoFactorAuthentication}
				onConfirm={() => setShowModalErrorTwoFactorAuthentication(false)}
			/>
			<ModalProcessingTwoFactorAuthentication show={email2FAStatusValidation.isFetching} />

			<Await2FAModal
				show={modals.twoFactor}
				onConfirm={handleTwoFactorModalConfirm}
				onCancel={handleTwoFactorModalCancel}
			/>
		</div>
	);
};

export default withRouter(NewOfferCreate);
